import { UnitUsersPage } from '@apps-common/apps/portal/pages/units/pages/manage/pages/users/Index'

export const UnitUsers = () => <UnitUsersPage />
